import React from 'react'
import styled from 'styled-components';

const StyledIcon = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  /* box-shadow: inset 0 0 0 1.5px ${props => props.color || '#000'}; */
  border: 2px solid rgb(156 163 175 / var(--tw-border-opacity, 1));
  border-radius: 50%;
  width: 30px;
  height: 30px;
  line-height: 24px;
  text-align: center;
`

const CircleIcon = (props: any) => {
  return (
    <StyledIcon {...props}>
      {<props.icon color={props.color} strokeWidth={props.strokeWidth} size={props.size}/>}
    </StyledIcon>
  )
}


export default CircleIcon
